<!--
 * @Descripttion: 
 * @version: 0.1
 * @Author: luoxi
 * @Date: 
 * @LastEditors: wanglong
 * @LastEditTime: 2021-09-03 11:15:20
 -->
<template>
  <div class="loading">
    <div class="box">
      <el-form
        :model="box"
        :rules="rules"
        status-icon
        label-position="left"
        label-width="80px"
        class="demo-ruleForm"
      >
        <el-form-item label="账号" prop="username">
          <el-input
            placeholder="请输入用户名"
            v-model="box.username"
          ></el-input>
        </el-form-item>
        <el-form-item label="邮箱" prop="email">
          <el-input placeholder="请输入邮箱" v-model="box.email"></el-input>
        </el-form-item>
        <el-form-item label="验证码" prop="code">
          <el-input placeholder="请输入验证码" v-model="box.code">
            <template slot="append">
              <div style="cursor: pointer" v-show="show" @click="getCodes">
                获取验证码
              </div>
              <div v-show="!show" class="count">{{ count }} s后重发</div>
            </template>
          </el-input>
          <p v-show="timeshow">
            验证码已发送到注册邮箱，请注意查收，验证码2分钟内有效
          </p>
        </el-form-item>
        <el-form-item label="新密码" prop="password">
          <el-input
            show-password
            placeholder="请输入密码"
            v-model="box.password"
          ></el-input>
        </el-form-item>
        <el-form-item label="再次输入" prop="password1">
          <el-input
            show-password
            placeholder="请再次输入密码"
            v-model="box.password1"
          ></el-input>
        </el-form-item>
      </el-form>
      <div id="btns">
        <div class="btn" @click="submins">提交</div>
      </div>
    </div>
  </div>
</template>

<script>
const Base64 = require("js-base64").Base64;
import { getCode, forgetPassWord, checkEmail } from "@/api/file";
import utils from "@/plugins/utils";

import cookies from "@/plugins/utils/cookies";
import resetPwd from "@/mixins/resetPwd";
export default {
  components: {},
  mixins:[resetPwd],
  data() {
    return {
      show: true,
      count: "",
      timer: null,
      timeshow: false,
      box: {
        email: "",
        code: "",
        password: "",
        password1: "",
        show: true,
        count: "",
        username: "",
      },
      rules: {
        email: [{ required: true, message: "请输入邮箱", trigger: "blur" }],
        username: [
          { required: true, message: "请输入用户名", trigger: "blur" },
        ],
        code: [{ required: true, message: "请输入验证码", trigger: "blur" }],
        password: [{ required: true, message: "请输入密码", trigger: "blur" }],
        password1: [{ required: true, message: "请确认密码", trigger: "blur" }],
      },
    };
  },
  watch: {},
  created() {},
  mounted() {},
  methods: {
    //提交
    submins() {
      let data = {
        email: this.box.email,
        capcha: this.box.code,
        newPassword: this.fromatPassword(this.box.password),
        rePassword: this.fromatPassword(this.box.password1),
      };
      forgetPassWord(data).then((res) => {
        if (res.code == 200) {
          this.$message.success("成功");
          this.$router.replace({ name: "login" });
        } else {
          this.$message.info(res.msg);
        }
      });
    },
    checkEmail() {
      let data = {
        email: this.box.email,
        userName: this.box.username,
      };
      return checkEmail(data).then((res) => {
        return res;
      });
    },

    //邮箱获取验证码
    async getCodes() {
      if (!this.box.username.trim()) {
        this.$message.info("请填用户名");
        return;
      } else if (!this.box.email) {
        this.$message.info("请填写正确的邮箱");
        return;
      } else {
        let data = await this.checkEmail();
        if (data.data == 1) {
          getCode(this.box.email).then((res) => {
            if (res.code == 200) {
              this.$message.success("验证码已发送邮箱");
              this.timeshow = true;
              const TIME_COUNT = 60;
              if (!this.timer) {
                this.count = TIME_COUNT;
                this.show = false;
                this.timer = setInterval(() => {
                  if (this.count > 0 && this.count <= TIME_COUNT) {
                    this.count--;
                  } else {
                    this.show = true;
                    clearInterval(this.timer);
                    this.timer = null;
                  }
                }, 1000);
              }
            }
          });
        } else {
          this.$message({
            showClose: true,
            message:
              "该账号绑定的邮箱与填写不一致，请联系相关人员找回正确的邮箱!",
            type: "warning",
            duration: 5000,
          });
        }
      }
    },
  },
};
</script>

<style scoped="" lang="scss">
* {
  padding: 0;
  margin: 0;
}

.loading {
  width: 100%;
  background: #29557b;
  height: 100%;
}

.box {
  height: 100%;
  margin: auto;
  width: 40%;
  background: white;
  min-width: 600px;
}
.box .el-form {
  padding-top: 50px;
  padding-left: 100px;
  padding-right: 120px;
}
.box ul {
  position: relative;
  top: 0px;
  padding-top: 50px;
  padding-left: 120px;
  padding-right: 120px;
}

.box ul > li {
  display: flex;
  margin-top: 14px;
  width: 100%;
}

.box ul > li p {
}

.box ul > li > div {
  width: 80%;
  margin-left: 20px;
}

.box ul > li div > label {
  font-size: 20px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #3c4353;
  line-height: 34px;
}

.box ul > li div > label span {
  color: #fc524c;
}

.box ul > li div > .el-input {
  min-width: 90%;
  margin-left: 20px;
}

.box ul > li > div {
  width: 100%;

  /deep/.el-input {
    .el-input-group__append {
      background: #167afc;
      color: rgba(255, 255, 255, 1);
      cursor: pointer;
      opacity: 0.5;
    }
  }
}

.box ul > li p {
  font-size: 16px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #24558b;
  line-height: 34px;
}

.btn {
  width: 100% !important;
  height: 60px;
  background: #24558b;
  opacity: 0.5;
  border-radius: 4px;
  text-align: center;
  font-size: 24px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #ffffff;
  line-height: 60px;
  cursor: pointer;
  margin-top: 50px;
}

.updata {
  justify-content: flex-end;
}

.tips {
  justify-content: space-between !important;
}

.boxss {
  text-align: right;

  span {
    cursor: pointer;
    margin-right: 20px;
  }
}
.el-form-item {
  margin-bottom: 22px;
}
#btns {
  width: 50%;
  margin: auto;
}
.el-input {
  min-width: 200px;
}
.el-select {
  min-width: 200px;
}
</style>
